@if (mediaType() === 'video') {
    <video #video
           playsinline
           preload="metadata"
           [src]="src()"
           [attr.type]="type() ?? null"
           [attr.poster]="poster() ?? null"
           [attr.aria-label]="ariaLabel() ?? null"
           controls>
        {{ 'iackathon.video_not_supported' | translate }}
    </video>
} @else {
    <audio #audio
           preload="metadata"
           [src]="src()"
           [attr.type]="type() ?? null"
           [attr.aria-label]="ariaLabel() ?? null"
           controls>
        {{ 'iackathon.audio_not_supported' | translate }}
    </audio>
}
